<template>
    <a-dropdown>
        <div class="header-avatar" style="cursor: pointer">
            <a-avatar v-if="$store.getters['account/user'].faceUrl" class="avatar" size="small" shape="circle" :src="$store.getters['account/user'].faceUrl | filterUrl"/>
            <span class="name" >{{$store.getters['account/user'].realName}}</span>
        </div>
        <a-menu :class="['avatar-menu']" slot="overlay">
            <a-menu-item @click="go()" v-permission="['/userCenter','/userCenter/userIndex']">
                <a-icon type="user"/>
                <span>个人中心</span>
            </a-menu-item>
            <!-- <a-menu-item>
                <a-icon type="setting"/>
                <span>设置</span>
            </a-menu-item> -->
            <a-menu-divider v-permission="['/userCenter','/userCenter/userIndex']"/>
            <a-menu-item @click="logout">
                <a-icon style="margin-right: 8px;" type="poweroff"/>
                <span>退出登录</span>
            </a-menu-item>
        </a-menu>
    </a-dropdown>
</template>

<script>
    export default {
        name: 'HeaderAvatar',
        // computed: {
        //   ...mapGetters('account', ['user']),
        // },
        data() {
            return {
                user: this.$store.getters["account/user"]
            }
        },
        methods: {
            logout() {
                this.$httpAu.logout().then(() => {
                    this.$router.push('/login')
                })
            },
            go() {
                this.$router.push('/userCenter/userIndex')
            }
        }
    }
</script>

<style lang="less">
    .header-avatar {
        display: inline-flex;
        .avatar, .name {
            align-self: center;
        }
        .avatar {
            margin-right: 8px;
        }
        .name {
            font-weight: 500;
        }
    }

    .avatar-menu {
        width: 150px;
    }

</style>
